import React from 'react';
import { BookOpenIcon, GiftIcon } from 'lucide-react';
import { Section } from './Shared';
import { KanjiBackdrop } from './Ornaments';
import { bonuses, interiorPages, tomes } from '../data/bonuses';
const kitCoverUrl = 'https://cdn.magicpatterns.com/uploads/gzAsXPZjQLXLmHKXYJ47gw/Portada_de_cuaderno_espiral_con_paisaje.png';
const packStats = [{
  value: '6 tomos',
  label: '300 páginas'
}, {
  value: '3 bonus',
  label: '150 páginas'
}, {
  value: '450',
  label: 'páginas en total'
}];
export function PackContents() {
  return <Section id="contenido" className="relative" data-id="element-133" data-mp="isduro2r7num">
      <KanjiBackdrop glyphs={['經', '絡', '五', '行', '道']} data-id="element-134" data-mp="44ala4pi5u12" />
      <div className="mx-auto max-w-4xl text-center" data-id="element-135" data-mp="43r5ounbrhq7">
        <span className="inline-flex items-center gap-1.5 rounded-full border border-stone-200 bg-white px-3 py-1 text-[10px] font-bold uppercase tracking-[0.18em] text-emerald-700 shadow-sm" data-id="element-136" data-mp="92c5isynzze4">
          <BookOpenIcon className="h-3.5 w-3.5 text-amber-700" aria-hidden="true" data-id="element-137" data-mp="11jyb9rpm45ro" />
          Mirá el kit por dentro
        </span>
        <h2 className="mt-4 text-[28px] font-bold leading-[1.15] tracking-tight text-stone-900 sm:text-4xl md:text-5xl" data-id="element-138" data-mp="3p864chvr70nb">
          Una biblioteca visual para continuar estudiando, repasar conceptos y{' '}
          <span className="relative z-0 inline-block px-1.5 text-red-700 before:absolute before:inset-x-0 before:bottom-[0.06em] before:-z-10 before:h-[0.4em] before:-rotate-1 before:rounded-sm before:bg-amber-200" data-id="element-139" data-mp="2tcw2mim4u5v">
            descubrir nuevas conexiones
          </span>{' '}
          entre las distintas ramas de la Medicina China.
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-stone-600 md:text-lg" data-id="element-140" data-mp="lqe5qkn43ig5">
          Seis tomos para recorrer sus fundamentos y disciplinas principales, más tres bonus para acompañar tu estudio. Un material amplio, organizado y visual, pensado para volver a él cuando quieras profundizar un tema.
        </p>
      </div>

      <ul className="mx-auto mt-10 grid max-w-6xl grid-cols-2 gap-3 md:grid-cols-6 md:gap-4" aria-label="Páginas interiores del kit" data-id="element-141" data-mp="2ik957ta9tt8y">
        {interiorPages.map((page, index) => <li key={page.title} className={`${index < 2 ? 'md:col-span-3' : 'md:col-span-2'} ${index === interiorPages.length - 1 ? 'col-span-2 md:col-span-2' : ''}`} data-id="element-142" data-mp="3c7wwox296adf" data-mpi={index}>
            <figure className="overflow-hidden rounded-xl border border-stone-200 bg-white shadow-sm" data-id="element-143" data-mp="3m6utsodqvc81">
              <img src={page.image} alt={`Página interior: ${page.title}`} loading="lazy" decoding="async" className="aspect-[4/3] w-full object-cover" data-id="element-144" data-mp="3r5xmragg9rzn" />
              <figcaption className="px-3 py-2.5 text-xs font-semibold text-stone-700 md:text-sm" data-id="element-145" data-mp="3v5zrjshhf1j5">
                {page.title}
              </figcaption>
            </figure>
          </li>)}
      </ul>

      <div className="mx-auto mt-8 max-w-5xl rounded-xl border border-stone-200 bg-white p-4 shadow-sm md:p-6" data-id="element-146" data-mp="8rgd5vsibmco">
        <div className="flex items-center gap-4 md:gap-6" data-id="element-147" data-mp="dsvxflmv1ou0">
          <img src={kitCoverUrl} alt="Portada del Kit Medicina Tradicional China" className="w-24 shrink-0 object-contain mix-blend-multiply drop-shadow-md sm:w-28 md:w-36" loading="lazy" decoding="async" data-id="element-148" data-mp="ipcp2pt9qlbu" />
          <div className="min-w-0" data-id="element-149" data-mp="1y8247tkqlcty">
            <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-red-700" data-id="element-150" data-mp="1yb6gzfc9pgw8">
              El pack principal
            </span>
            <h3 className="mt-0.5 text-lg font-bold leading-tight tracking-tight text-stone-900 sm:text-xl md:text-2xl" data-id="element-151" data-mp="1obfk5708ipsz">
              KIT MEDICINA TRADICIONAL CHINA™
            </h3>
            <p className="mt-1.5 max-w-2xl text-sm leading-snug text-stone-600 md:text-base" data-id="element-152" data-mp="2gzuzxvr6xc5d">
              Una biblioteca visual de estudio para terapeutas y practicantes con
              formación previa que quieren ampliar sus conocimientos y explorar
              distintas ramas de la Medicina China.
            </p>
            <p className="mt-2 text-[10px] font-bold uppercase tracking-[0.1em] text-emerald-700 md:text-xs" data-id="element-153" data-mp="34pfhca7p41cj">
              {packStats.map(stat => `${stat.value} · ${stat.label}`).join('  |  ')}
            </p>
          </div>
        </div>

        <ul className="mt-4 grid gap-x-6 gap-y-3 border-t border-stone-200 pt-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-154" data-mp="2kf4olmao69ox">
          {tomes.map(tome => <li key={tome.label} className="flex gap-3" data-id="element-155" data-mp="2aii1equvf6jq">
              <img src={tome.cover} alt={`Portada del ${tome.label}: ${tome.title}`} loading="lazy" decoding="async" className="aspect-[3/4] w-10 shrink-0 self-start rounded border border-stone-300 bg-stone-900 object-cover shadow-sm md:w-12" data-id="element-156" data-mp="2ak2wqip0etin" />
              <div className="min-w-0" data-id="element-157" data-mp="385qt53lgtbu6">
                <p className="text-[13px] font-bold leading-snug text-stone-900" data-id="element-158" data-mp="384p8q8ik7czs">
                  <span className="uppercase tracking-[0.06em] text-red-700" data-id="element-159" data-mp="2tg2sm4l3yh7i">
                    {tome.label}
                  </span>{' '}
                  — {tome.title}
                </p>
                <p className="mt-0.5 text-xs leading-snug text-stone-500" data-id="element-160" data-mp="3m5jeeje82zur">
                  {tome.description}
                </p>
              </div>
            </li>)}
        </ul>

        <p className="mt-4 border-t border-stone-200 pt-3 text-xs leading-relaxed text-stone-500 md:text-center" data-id="element-161" data-mp="1fh9ebefwmm9z">
          Una biblioteca para recorrer distintas áreas de la Medicina China con
          contenidos de estudio y recursos visuales para seguir aprendiendo.
        </p>
      </div>

      <div className="mx-auto mt-10 max-w-5xl rounded-xl border border-stone-200 bg-white p-5 shadow-sm md:p-6" data-id="element-162" data-mp="1k8hnc9dbo5mm">
        <div className="flex flex-col items-center gap-2 border-b border-stone-200 pb-4 text-center sm:flex-row sm:justify-between sm:text-left" data-id="element-163" data-mp="wi596grhhcnl">
          <h3 className="flex items-center gap-2 text-lg font-bold tracking-tight text-stone-900 md:text-xl" data-id="element-164" data-mp="rleqdloao2yh">
            <GiftIcon className="h-5 w-5 text-amber-700" aria-hidden="true" data-id="element-165" data-mp="15h8t1myh5w35" />
            3 BONOS DE ESTUDIO — <span className="text-emerald-700" data-id="element-166" data-mp="11jugblbl566e">GRATIS</span>
          </h3>
          <p className="text-[11px] font-semibold uppercase tracking-[0.12em] text-stone-500" data-id="element-167" data-mp="2gwxc438lyayo">
            150 páginas adicionales · Sin costo extra
          </p>
        </div>
        <ul className="mt-4 grid gap-4 md:grid-cols-3 md:gap-6" data-id="element-168" data-mp="19kxz9glenkxs">
          {bonuses.map(bonus => <li key={bonus.n} className="flex items-start gap-3" data-id="element-169" data-mp="1ekklgfj7obiq">
              <img src={bonus.cover} alt={`Portada del bonus ${bonus.n}: ${bonus.title}`} loading="lazy" decoding="async" className="aspect-[3/4] w-16 shrink-0 object-contain mix-blend-multiply drop-shadow-md md:w-20" data-id="element-170" data-mp="1emx5cy8j4vyf" />
              <div className="min-w-0" data-id="element-171" data-mp="qvrm093drljd">
                <p className="text-[11px] font-bold uppercase tracking-wide text-red-700" data-id="element-172" data-mp="qx2sigo7n7e6">
                  Bonus {bonus.n}
                </p>
                <p className="mt-0.5 text-sm font-semibold leading-snug text-stone-900" data-id="element-173" data-mp="zw7r1mzrv0qc">
                  {bonus.title}
                </p>
                <p className="mt-1 text-xs leading-relaxed text-stone-500" data-id="element-174" data-mp="14ny25v6j9sit">
                  {bonus.description}
                </p>
              </div>
            </li>)}
        </ul>
      </div>
    </Section>;
}